import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { PropTypes } from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const PhotographLogo = ({
  photographId,
  photographName,
  photographUrlId,
}) => {
  const theme = useTheme();
  const [hasError, setHasError] = useState(null);
  const navigate = useNavigate();

  if (hasError) {
    return (
      <Typography
        variant="h3"
        sx={{
          flexGrow: 1,
          textAlign: "left",
          color: theme.palette.secondary.dark,
        }}
        href={`/photographs/${photographUrlId}`}
      >
        {photographName}
      </Typography>
    );
  }
  return (
    <Box
      onClick={() => navigate(`/photographs/${photographUrlId}`)}
      component={"img"}
      src={`${process.env.REACT_APP_CLOUDFRONT_URL}/logos/${photographId}`}
      maxHeight={50}
      maxWidth={"25%"}
      onError={(e) => {
        setHasError(true);
      }}
      type={"image"}
      alt={photographName}
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
        fontSize: 24,
      }}
    />
  );
};

PhotographLogo.propTypes = {
  photographId: PropTypes.string.isRequired,
  photographName: PropTypes.string.isRequired,
  photographUrlId: PropTypes.string.isRequired,
};

export default PhotographLogo;
